const NAVIGATE_URL = {
  QMAS_CREATE_JOB: `${process.env.REACT_APP_QMAS_URL}/inspection/jobs/new`
};

export default NAVIGATE_URL;
